import React, { memo } from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  RadioGroup,
  Radio,
} from '@mui/material';
import { FormControlLabel } from '~/UIKit';

import { FilterItemsStyles } from './FilterItems.styles';

interface IFilterRadioButtonList {
  selectItem: (id: string) => void;
  selectedItem: string;
  list: { value: string; label: React.ReactNode; icon?: React.ReactNode }[];
}
export const FilterRadioButtonList = memo(
  ({ selectItem, selectedItem, list }: IFilterRadioButtonList) => {
    const { classes } = FilterItemsStyles();

    return (
      <List className={classes.list}>
        <RadioGroup
          aria-label="eventStatus"
          name="eventStatus"
          value={selectItem}
          className={classes.radioGroup}
        >
          {list.map(({ value, label, icon }, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton
                role={undefined}
                onClick={() => selectItem(value)}
                dense
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemCheckboxContainer}>
                  <FormControlLabel
                    value={label}
                    control={<Radio />}
                    label=""
                    className={classes.radio}
                    checked={selectedItem === value}
                  />
                </ListItemIcon>
                {icon && <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>}
                <ListItemText classes={{ primary: classes.titleText }} id={value} primary={label} />
              </ListItemButton>
            </ListItem>
          ))}
        </RadioGroup>
      </List>
    );
  },
);
